import axios from '@/api/axios'
import { resourceConstructor } from '@/api'

const constructFullUrl = resourceConstructor('enrollment')

export default {
  retrieveCourses: userId =>
    axios.get(constructFullUrl(`user-course-qa/${userId}`)),

  markAsEvaluated: ({ userId, uuid, data, qualification }) =>
    axios.put(
      constructFullUrl(
        `user-${
          qualification ? 'qualification' : 'course'
        }-qa/${userId}/${uuid}`
      ),
      data
    ),
}
